export default __webpack_public_path__ + "static/media/Paws_up_intro.ebe41d7e.jpg";